import React, { memo } from 'react';
import { TickIcon } from '../../../assets/icons';
import CSS from './Checkbox.module.scss';

interface IParentProps {
	onChange: (checked: boolean) => unknown;
	checked: boolean;
	label?: string;
	disabled?: boolean;
}

const Checkbox: React.FunctionComponent<IParentProps> = ({ onChange, checked, label, disabled = false }) => {
	const classes = [CSS.Checkbox];
	if (checked) classes.push(CSS.Active);
	if (disabled) classes.push(CSS.Disabled);

	return (
		<>
			<div className={classes.join(' ')} onClick={disabled ? undefined : () => onChange(!checked)} data-testid="Checkbox">
				{checked && <TickIcon hexFill={'#FFFFFF'} />}
			</div>
			{label && (
				<span className={`${CSS.ChkbxLabel} ${disabled ? CSS.Disabled : ''}`} onClick={disabled ? undefined : () => onChange(!checked)} data-testid="CheckboxLabel">
					{label}
				</span>
			)}
		</>
	);
};

export default memo(Checkbox);
